// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3NO8R","filesListContainer":"PosDisputesFiles_filesListContainer__34b8h","filesButton":"PosDisputesFiles_filesButton__PCUt5"};